import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import contentImage from "../../assets/images/desktopFinal.png"; 

import './immersiveNew.css'

const BespokeContent = () => {
  return (
    <div className="bespoke-content-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <div className="bespoke-image">
              <img src={contentImage} alt="Bespoke Content" />
            </div>
          </Col>

          <Col md={6}>
            <div className="bespoke-text">
              <h4>Bespoke Content Development</h4>
              <p>
                With a team of <strong>30+ dedicated software developers</strong>, 
                we create impactful XR scenarios aligned to your specific 
                training requirements, including:
              </p>
              <ul>
                <li><strong>Healthcare simulations</strong> for real-world application.</li>
                <li><strong>Custom scenarios</strong> tailored to educational curricula.</li>
                <li><strong>Engaging VR experiences</strong> that enhance learning retention.</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BespokeContent;
